import Vue from 'vue'
import Router from 'vue-router'
import AuthRequired from '@/utils/AuthRequired'
import { apiUrl, xtools } from '@/constants/config'
import axios from 'axios'
import moment from 'moment'
import linq from 'js-linq'
// import $, { data } from 'jquery';
// import { controllers } from 'chart.js'

const $linq = function (arr) {
  return linq.from(arr)
}
Vue.use(Router)

const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: 'app' */ './views/app'),
    redirect: '/app/transaction',
    beforeEnter: AuthRequired,
    children: [
      {
        path: 'app/home',
        component: () => import('./views/app/home'),
        meta: {
          auth: true,
          module: 'ACL',
          mangoMenu: {
            menu_name: 'M_ACL',
            nameMenu: '403',
            menu_id: '10000',
            menu_sub: [],
            checkUserRight: false
          }
        }
      },
      {
        path: 'app/transaction',
        component: () => import(/* webpackChunkName: 'master' */ './views/app/transaction'), meta: {
          auth: true,
          menu_id: 1,
          module: 'ACL',
          nameMenu: 'Transaction',
          mangoMenu: {
            menu_name: 'M_ACL',
            menu_id: '10000',
            menu_sub: [],
            checkUserRight: true
          }
        },
        redirect: './app/transaction/trn_labour',
        children: [
          {
            path: 'trn_labour', component: () => import(/* webpackChunkName: 'user' */ './views/app/transaction/trn_labour'), meta: {
              auth: true,
              menu_id: 1,
              nameMenu: 'Setup Labour',
              module: 'ACL',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '10200',
                menu_sub: ['10210', '10220'],
                checkUserRight: true
              }
            }
          },
          {
            path: 'trn_planY', component: () => import(/* webpackChunkName: 'user' */ './views/app/transaction/trn_planY'), meta: {
              auth: true,
              menu_id: 1,
              nameMenu: 'Setup PlanY',
              module: 'ACL',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '10100',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'trn_labour_pay', component: () => import(/* webpackChunkName: 'user' */ './views/app/transaction/trn_labour_pay'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Labour To Pay',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '10300',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'trn_labour_pay_em', component: () => import(/* webpackChunkName: 'user' */ './views/app/transaction/trn_labour_pay_em'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Labour To Pay employee',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '10500',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'trn_labour_pay_new', component: () => import(/* webpackChunkName: 'user' */ './views/app/transaction/trn_labour_pay_new'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Labour To Pay New',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '',
                menu_sub: [],
                checkUserRight: false
              }
            }
          },
          {
            path: 'trn_labour_pay_edit', component: () => import(/* webpackChunkName: 'user' */ './views/app/transaction/trn_labour_pay_edit'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Labour To Pay Edit',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '',
                menu_sub: [],
                checkUserRight: false
              }
            }
          },
          {
            path: 'trn_labour_pay_list', component: () => import(/* webpackChunkName: 'user' */ './views/app/transaction/trn_labour_pay_list'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Labour To Pay List',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '',
                menu_sub: [],
                checkUserRight: false
              }
            }
          },
          {
            path: 'trn_labour_pay_list_em', component: () => import(/* webpackChunkName: 'user' */ './views/app/transaction/trn_labour_pay_list_em'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Labour To Pay List employee',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '',
                menu_sub: [],
                checkUserRight: false
              }
            }
          },
          {
            path: 'trn_image_gallery', component: () => import(/* webpackChunkName: 'user' */ './views/app/transaction/trn_image_gallery'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Image Check in & Check Out',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '',
                menu_sub: [],
                checkUserRight: false
              }
            }
          },
          {
            path: 'trn_plan_extra', component: () => import(/* webpackChunkName: 'user' */ './views/app/transaction/trn_plan_extra'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup Plan Extra',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '10400',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'trn_planY_share_service', component: () => import(/* webpackChunkName: 'user' */ './views/app/transaction/trn_planY_share_service'), meta: {
              auth: true,
              menu_id: 1,
              nameMenu: 'Setup PlanY Share Service',
              module: 'ACL',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '10600',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'trn_labour_share_service', component: () => import(/* webpackChunkName: 'user' */ './views/app/transaction/trn_labour_share_service'), meta: {
              auth: true,
              menu_id: 1,
              nameMenu: 'Setup Labour Share Service',
              module: 'ACL',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '10700',
                menu_sub: ['10710', '10720', '10730'],
                checkUserRight: true
              }
            }
          },
          {
            path: 'trn_image_ro_gallery', component: () => import(/* webpackChunkName: 'transaction' */ './views/app/transaction/trn_image_ro_gallery'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Image Check In & Check Out For RO',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '10900',
                menu_sub: ['10710'],
                checkUserRight: true
              }
            }
          },
          {
            path: 'trn_labour_pay_ro', component: () => import(/* webpackChunkName: 'transaction' */ './views/app/transaction/trn_labour_pay_ro'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Labour To Pay Share Service',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '10800',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'trn_labour_pay_ro_list', component: () => import(/* webpackChunkName: 'user' */ './views/app/transaction/trn_labour_pay_ro_list'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Labour To Pay Share Service List',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '',
                menu_sub: [],
                checkUserRight: false
              }
            }
          },
          //Logs setting
          {
            path: 'logs', component: () => import(/* webpackChunkName: 'user' */ './views/app/transaction/trn_logs'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Logs',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '30300',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
        ]
      },
      {
        path: 'app/master',
        component: () => import(/* webpackChunkName: 'master' */ './views/app/master'), meta: {
          auth: true,
          menu_id: 1,
          module: 'ACL',
          nameMenu: 'Master',
          mangoMenu: {
            menu_name: 'M_ACL',
            menu_id: '20000',
            menu_sub: [],
            checkUserRight: true
          }
        },
        redirect: './app/master/mas_account',
        children: [
          {
            path: 'lab',
            component: () => import('./views/app/master/lab.vue'),
            auth: true,
            menu_id: null,
            module: 'ACL',
            nameMenu: 'LAB',
            mangoMenu: {
              menu_name: 'M_ACL',
              menu_id: '',
              menu_sub: [],
              checkUserRight: false
            }
          },
          {
            path: 'mas_employee_to_team', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_employee_to_team'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup Outsource To Team',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '',
                menu_sub: [],
                checkUserRight: false
              }
            }
          },
          {
            path: 'mas_employee', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_employee'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup Oursource',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '20100',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'mas_employee_import', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_employee_import'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Import Data',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '',
                menu_sub: [],
                checkUserRight: false
              }
            }
          },
          {
            path: 'mas_employee_exportContract', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_employee_exportContract'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Export Contract',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '',
                menu_sub: [],
                checkUserRight: false
              }
            }
          },
          {
            path: 'mas_account', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_account'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup Account',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '20200',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'mas_expenses_other', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_expenses_other'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup Expense Other',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '20300',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'mas_location', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_location'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup Location',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '',
                menu_sub: [],
                checkUserRight: false
              }
            }
          },
          {
            path: 'mas_position', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_position'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup Position',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '20400',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'mas_position_to_project', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_position_to_project'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup Position/KPI To Project',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '20500',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'mas_province', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_province'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup Province',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '20600',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'mas_store', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_store'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup Store',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '20700',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'mas_team', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_team'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup Team',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '',
                menu_sub: [],
                checkUserRight: false
              }
            }
          },
          {
            path: 'mas_holiday', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_holiday'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup Holiday',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '20800',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'mas_kpi', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_kpi'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup KPI',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '20900',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          //New Master
          {
            path: 'mas_jobs_detail', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_jobs_detail'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup Jobs Detail',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '21000',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'mas_welfare', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_welfare'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup Welfare',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '21100',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'mas_end_contract_group', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_end_contract_group'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup group Jobs and Welfare',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '21300',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'mas_regulations', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_regulations'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup Regulations',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '21200',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'mas_ro_brands', component: () => import(/* webpackChunkName: 'user' */ './views/app/master/mas_ro_brands'),
            meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'RO Brands',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '',
                menu_sub: [],
                checkUserRight: false
              }
            }
          },
          {
            path: 'mas_province_share_service', component: () => import(/* webpackChunkName: 'master' */ './views/app/master/mas_province_share_service'),
            meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup Province Share Service',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '21500',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'mas_store_share_service', component: () => import(/* webpackChunkName: 'master' */ './views/app/master/mas_store_share_service'),
            meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'Setup Store Share Service',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '21600',
                menu_sub: [],
                checkUserRight: true
              }
            }
          }

        ]
      },
      {
        path: 'app/report',
        component: () => import(/* webpackChunkName: 'master' */ './views/app/report'),
        redirect: './app/report/fromLabour',
        children: [
          {
            path: 'fromLabour', component: () => import('./views/app/report/fromLabour'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'From Labour',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '30100',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          {
            path: 'report_checkInOut', component: () => import('./views/print/report_checkInOut'), meta: {
              auth: true,
              menu_id: 1,
              module: 'ACL',
              nameMenu: 'รายงานการทำงาน Outsource',
              mangoMenu: {
                menu_name: 'M_ACL',
                menu_id: '30200',
                menu_sub: [],
                checkUserRight: true
              }
            }
          },
          // { path: 'reportLabour', component: () => import('./views/app/report/reportLabour') }
        ]
      },
      {
        path: 'app/dashboards',
        component: () => import(/* webpackChunkName: 'dashboards' */ './views/app/dashboards'),
        redirect: '/app/dashboards/default',
        children: [
          { path: 'trn_labour', component: () => import(/* webpackChunkName: 'dashboards' */ './views/app/dashboards/trn_labour') },
          { path: 'default', component: () => import(/* webpackChunkName: 'dashboards' */ './views/app/dashboards/Default') },
          { path: 'analytics', component: () => import(/* webpackChunkName: 'dashboards' */ './views/app/dashboards/Analytics') },
          { path: 'ecommerce', component: () => import(/* webpackChunkName: 'dashboards' */ './views/app/dashboards/Ecommerce') },
          { path: 'content', component: () => import(/* webpackChunkName: 'dashboards' */ './views/app/dashboards/Content') }
        ]
      },
      {
        path: 'app/pages',
        component: () => import(/* webpackChunkName: 'pages' */ './views/app/pages'),
        redirect: '/app/pages/data-list',
        children: [
          { path: 'data-list', component: () => import(/* webpackChunkName: 'pages' */ './views/app/pages/DataList') },
          { path: 'thumb-list', component: () => import(/* webpackChunkName: 'pages' */ './views/app/pages/ThumbList') },
          { path: 'image-list', component: () => import(/* webpackChunkName: 'pages' */ './views/app/pages/ImageList') },
          { path: 'details', component: () => import(/* webpackChunkName: 'pages' */ './views/app/pages/Details') },
          { path: 'search', component: () => import(/* webpackChunkName: 'pages' */ './views/app/pages/Search') },
          { path: 'mailing', component: () => import(/* webpackChunkName: 'pages' */ './views/app/pages/Mailing') },
          { path: 'invoice', component: () => import(/* webpackChunkName: 'pages' */ './views/app/pages/Invoice') }
        ]
      },
      {
        path: 'app/applications',
        component: () => import(/* webpackChunkName: 'applications' */ './views/app/applications'),
        redirect: '/app/applications/todo',
        children: [
          { path: 'todo', component: () => import(/* webpackChunkName: 'applications' */ './views/app/applications/Todo') },
          { path: 'survey', component: () => import(/* webpackChunkName: 'applications' */ './views/app/applications/Survey') },
          { path: 'survey/:id', component: () => import(/* webpackChunkName: 'applications' */ './views/app/applications/SurveyDetail'), props: true },
          { path: 'chat', component: () => import(/* webpackChunkName: 'applications' */ './views/app/applications/Chat') }
        ]
      },
      {
        path: 'app/ui',
        component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui'),
        redirect: '/app/ui/alerts',
        children: [
          { path: 'alerts', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/Alerts') },
          { path: 'badges', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/Badges') },
          { path: 'buttons', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/Buttons') },
          { path: 'cards', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/Cards') },
          { path: 'carousel', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/Carousel') },
          { path: 'charts', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/Charts') },
          { path: 'collapse', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/Collapse') },
          { path: 'dropdowns', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/Dropdowns') },
          { path: 'editors', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/Editors') },
          { path: 'forms', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/Forms') },
          { path: 'form-components', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/FormComponents') },
          { path: 'icons', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/Icons') },
          { path: 'input-groups', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/InputGroups') },
          { path: 'jumbotron', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/Jumbotron') },
          { path: 'maps', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/Maps') },
          { path: 'modal', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/Modal') },
          { path: 'navigation', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/Navigation') },
          { path: 'popover-tooltip', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/PopoverTooltip') },
          { path: 'sortable', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/Sortable') },
          { path: 'tables', component: () => import(/* webpackChunkName: 'ui' */ './views/app/ui/Tables') }
        ]
      }
    ]
  },
  { path: '/access_denied', component: () => import(/* webpackChunkName: 'error' */ './views/app/Access_denied') },
  { path: '/error', component: () => import(/* webpackChunkName: 'error' */ './views/Error') },
  {
    path: '/user',
    component: () => import(/* webpackChunkName: 'user' */ './views/user'),
    redirect: '/user/login',
    children: [
      { path: 'login', component: () => import(/* webpackChunkName: 'user' */ './views/user/Login') },
      { path: 'register', component: () => import(/* webpackChunkName: 'user' */ './views/user/Register') },
      { path: 'forgot-password', component: () => import(/* webpackChunkName: 'user' */ './views/user/ForgotPassword') }
    ]
  },
  {
    path: '/supervisor',
    component: () => import(/* webpackChunkName: 'user' */ './views/supervisor'),
    redirect: '/supervisor/checklist',
    children: [
      { path: 'checklist', component: () => import(/* webpackChunkName: 'user' */ './views/supervisor/checklist') }
    ]
  },
  {
    path: '/outsource',
    component: () => import(/* webpackChunkName: 'user' */ './views/outsource'),
    redirect: '/outsource/checkin',
    children: [
      { path: 'checkin', component: () => import(/* webpackChunkName: 'user' */ './views/outsource/checkin') },
      { path: 'history', component: () => import(/* webpackChunkName: 'user' */ './views/outsource/history') }
    ]
  },
  {
    path: '/print',
    component: () => import(/* webpackChunkName: 'user' */ './views/print'),
    redirect: '/print/printPlanY',
    children: [
      { path: 'printPlanY', component: () => import(/* webpackChunkName: 'user' */ './views/print/printPlanY') },
      { path: 'printLabour', component: () => import(/* webpackChunkName: 'user' */ './views/print/printLabour') },
      { path: 'printLabourForCustomer', component: () => import(/* webpackChunkName: 'user' */ './views/print/printLabourForCustomer') },
      { path: 'report_checkInOut', component: () => import(/* webpackChunkName: 'user' */ './views/print/report_checkInOut') },
      { path: 'printLabourROForCustomer', component: () => import(/* webpackChunkName: 'user' */ './views/print/printLabourROForCustomer') },
      { path: 'printLabourTimeChecker', component: () => import(/* webpackChunkName: 'user' */ './views/print/printLabourTimeChecker') },
    ]
  },
  {
    path: '/pubilc',
    component: () => import(/* webpackChunkName: 'publi' */ './views/pubilc'),
    redirect: '/pubilc/loginmobile',
    children: [
      { path: 'signup', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/signup') },
      { path: 'loginmobile', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/loginmobile') },
      /*{ path: 'checkin', component: () => import(*//* webpackChunkName: 'user' *//* './views/pubilc/checkin') },*/
      { path: 'history', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/history') },
      { path: 'supervisorlist', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/supervisorlist') },
      { path: 'request_otp', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/request_otp') },
      { path: 'contract', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/contract') },
      { path: 'jobview', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/jobview') },
      { path: 'jobview_ro', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/jobview_ro') },
      { path: 'jobslist', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/jobslist') },
      { path: 'wronglist', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/wronglist') },
      { path: 'statuschangelist', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/statuschangelist') },
      { path: 'wrongview', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/wrongview') },
      { path: 'statuschangeview', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/statuschangeview') },
      { path: 'contract_em', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/contract_em') },
      { path: 'contract_cancel', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/contract_cancel') },
      { path: 'share_store', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/share_store') },
      //call_cards
      { path: 'call_cards', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/call_cards') },
      { path: 'approve_batch', component: () => import(/* webpackChunkName: 'user' */ './views/pubilc/approve_batch.vue') },
    ]
  }, ,
  {
    path: '*', component: () => import(/* webpackChunkName: 'error' */ './views/Error'), meta: {
      auth: true,
      menu_id: 1,
      module: 'ACL',
      nameMenu: '404',
    }
  }
]

const router = new Router({
  linkActiveClass: 'active',
  routes,
  mode: 'history'
})

// var token = localStorage.getItem('token');

let t = this

router.beforeEach(async (to, from, next) => {
  var then = localStorage.getItem('time')
  var now = new moment().format('HH:mm:ss')
  var dff = moment.utc(moment(now, 'HH:mm:ss').diff(moment(then, 'HH:mm:ss'))).format('m')
  var public_path = [
    '/user/login',
    '/pubilc/signup',
    '/pubilc/loginmobile',
    '/pubilc/checkin',
    '/supervisor/checklist',
    '/pubilc/supervisorlist',
    '/pubilc/history',
    '/pubilc/request_otp',
    '/pubilc/contract',
    '/pubilc/jobslist',
    '/pubilc/jobview',
    '/pubilc/jobview_ro',
    '/pubilc/wronglist',
    '/pubilc/statuschangelist',
    '/pubilc/wrongview',
    '/pubilc/statuschangeview',
    '/pubilc/contract_em',
    '/pubilc/contract_cancel',
    '/pubilc/share_store',
    '/pubilc/call_cards',
    '/pubilc/approve_batch'

  ];

  //if (to.path != '/user/login' && to.path != '/pubilc/signup' && to.path != '/pubilc/loginmobile' && to.path != '/pubilc/checkin' && to.path != '/supervisor/checklist' && to.path != '/pubilc/supervisorlist' && to.path != '/pubilc/history' && to.path != '/pubilc/request_otp')
  if (!public_path.includes(to.path)) {
    let menu_name = ''
    let menuId = ''
    let checkRight = false

    if (!xtools.isEmpty(to.meta.mangoMenu)) {
      if (to.meta.mangoMenu && to.meta.mangoMenu.checkUserRight) {
        checkRight = true
        menu_name = to.meta.mangoMenu.menu_name || ''
        menuId = to.meta.mangoMenu.menu_id || ''
      }
    }

    const axioscustom = axios.create()
    axioscustom.defaults.headers.common['X-Mango-Auth'] = localStorage.getItem('token_dc') || ''
    let resp = await axioscustom.post(apiUrl + `api/public/ViewInitData2?menu_name=${menu_name}`, {})

    if (!resp.data.data.auth.is_authen) {
      return next('/user/login')
    } else {
      let userRight = resp.data.data.menu_right || []
      let auth = resp.data.data.auth || [];

      window.userRight = userRight
      window.auth = auth;
      /* set menu right */
      if (!xtools.isEmpty(to.meta.mangoMenu)) {
        if (!xtools.isEmpty(to.meta.mangoMenu.menu_id)) {
          let menuRight = $linq(resp.data.data.menu_right).where(x => x.menu_name == to.meta.mangoMenu.menu_name && x.menu_id == to.meta.mangoMenu.menu_id).firstOrDefault()

          let subMenuRight = [];
          if (to.meta.mangoMenu.menu_sub.length > 0) {
            to.meta.mangoMenu.menu_sub.forEach(x => {
              let sub = $linq(resp.data.data.menu_right).where(i => i.menu_name == to.meta.mangoMenu.menu_name && i.menu_id == x).firstOrDefault();
              if (!xtools.isEmpty(sub)) {
                subMenuRight.push(sub);
              }
            })
          }
          // console.log(subMenuRight);
          window.menuRight = menuRight;
          window.subMenuRight = subMenuRight;
        }
      }

      /* check user right */
      if (checkRight && to.name !== 'access_denied' && resp.data.data.auth.is_authen) {
        let isEnable = $linq(window.userRight).any(x => x.menu_id === menuId && x.isenabled === 1)
        if (!isEnable) {
          window.previousPage = to.meta.nameMenu;
          return next('/app/home');
        }
      }

      localStorage.setItem('dc_empname', resp.data.data.auth.empname)
      localStorage.setItem('time', new moment().format('HH:mm:ss'))

      let tmp = {
        module: 'ACL',
        view_name: to.meta.nameMenu,
        view_title: to.meta.nameMenu,
      }
      if (!xtools.isEmpty(to.meta.mangoMenu)) {
        if (to.meta.nameMenu != '404' && to.meta.mangoMenu.nameMenu != '403') {
          if (to.hash == '') {
            axioscustom.post(apiUrl + `Api/ErrorLog/CreateAccessLog`, tmp);
          }
        }
      }
      next()
    }
  } else {
    next()
  }

  // var token = localStorage.getItem('token');
  // if(token==''){
  //   //alert('ok');
  //   next('/user/login')
  // }

  // if(dff > 30){
  //   if(to.path != '/user/login') {
  //     const axioscustom = axios.create();
  //     axioscustom.defaults.headers.common['X-Mango-Auth'] = localStorage.getItem('token') || '';
  //     let resp = await axioscustom.post(apiUrl+'api/public/ViewInitData', {});
  //     if(!resp.data.data.auth.is_authen){
  //       return next('/user/login')
  //     }else{
  //       localStorage.setItem('time', new moment().format('HH:mm:ss'));
  //       next()
  //     }
  //   } else {
  //       next();
  //   }
  // }else{
  //   next();
  // }
})

export default router
